"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PERSON_VIEWS = void 0;
exports.PERSON_VIEWS = ["students", "staff", "all"];
